<template>
  <div>
    <div class="pc_all GenerateManagement LogoFile">
      <div class="GenerateManagementContent">
        <div class="GenerateManagementContent_nav">
          <div class="GenerateManagementContent_nav_left">
            <div class="nav_left_dd font20">社交头像</div>
            <div class="nav_left_dt font14">
              全部原创设计，线上/线下全渠道，皆可商用。支持下载JPG、PNG和SVG源文件等格式
            </div>
          </div>
          <div class="GenerateManagementContent_nav_share">
            分享<img alt="" src="@a/ailogo/images/sv14.svg" />
          </div>
        </div>
        <div class="SocialProfilePicture">
          <div class="SocialProfilePicture_left">
            <div class="SocialProfilePicture_left_nav">
              <div class="left_nav_list" v-for="(item, index) in navItems" :key="index" @click="selectNavItem(index)"
                :class="{ active: selectedNavIndex === index }">
                <div class="nav_list_icon iconfont" :class="item.icon"></div>
                <div class="nav_list_title font14">{{ item.title }}</div>
                <div class="nav_list_size font14">{{ item.size }}</div>
                <div class="nav_list_downlad">
                  <span class="font12" @click="downloadAsPNG(item.size)"><img alt="" src="@a/ailogo/images/sv3.svg" />下载</span>
                </div>
              </div>
            </div>
          </div>
          <div class="SocialProfilePicture_right">
            <div class="SocialProfilePicture_right_list" v-for="(rightImage, index) in rightImages" :key="index"
              :class="{ active: selectedNavIndex === index }">
              <img :alt="rightImage.name" :src="rightImage.image" />
              <div class="right_list_title">{{ title }}</div>
              <div class="right_list_logo"><img :alt="rightImage.name" :src="oriImage"   class="scaled-image"/></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    picturesAndTextsWithBackground: null,
    // canvas: null,
    independentPatternWithBackground: null,
    picturesAndTexts: null,
    independentPattern: null,
    svgBaseUrl: null,
    croppedImage: null,
    background: null,
    oriImage: null,
    title:null,
    // canvasWidth: 1200,
    // canvasHeight: 900,
  },
  data() {
    return {
      GenerateManagementWindowActive: false,
      navItems: [
        { icon: 'icon-weixin', title: '微信公众号', size: '480*480' },
        { icon: 'icon-weixinxiaochengxu', title: '微信小程序', size: '480*480' },
        { icon: 'icon-douyin', title: '抖音', size: '480*480' },
        { icon: 'icon-xiaohongshu', title: '小红书', size: '480*480' },
        { icon: 'icon-xinlangweibo', title: '微博', size: '480*480' },
        { icon: 'icon-zhihu', title: '知乎', size: '480*480' },
        { icon: 'icon-meituan', title: '美团', size: '480*480' },
        { icon: 'icon-elment', title: '饿了么', size: '480*480' },
        { icon: 'icon-kuaishou', title: '快手', size: '480*480' }
      ],
      rightImages: [
        {
          image: require('@a/ailogo/images/bn7.png'),
          logo: require('@a/ailogo/images/bn16.png'),
          title: '龙虾第一乡',
        },
        {
          image: require('@a/ailogo/images/bn20.png'),
          logo: require('@a/ailogo/images/bn16.png'),
          title: '龙虾第一乡',
        },
        {
          image: require('@a/ailogo/images/bn21.png'),
          logo: require('@a/ailogo/images/bn16.png'),
          title: '龙虾第一乡',
        },
        {
          image: require('@a/ailogo/images/bn22.png'),
          logo: require('@a/ailogo/images/bn16.png'),
          title: '龙虾第一乡',
        },
        {
          image: require('@a/ailogo/images/bn23.png'),
          logo: require('@a/ailogo/images/bn16.png'),
          title: '龙虾第一乡',
        },
        {
          image: require('@a/ailogo/images/bn24.png'),
          logo: require('@a/ailogo/images/bn16.png'),
          title: '龙虾第一乡',
        },
        {
          image: require('@a/ailogo/images/bn25.png'),
          logo: require('@a/ailogo/images/bn16.png'),
          title: '龙虾第一乡',
        },
        {
          image: require('@a/ailogo/images/bn26.png'),
          logo: require('@a/ailogo/images/bn16.png'),
          title: '龙虾第一乡',
        },
        {
          image: require('@a/ailogo/images/bn27.png'),
          logo: require('@a/ailogo/images/bn16.png'),
          title: '龙虾第一乡',
        }
      ],
      selectedNavIndex: 0
    }
  },
  methods: {
    downloadAsPNG(size) {
      // 解析传入的尺寸
      const [newWidth, newHeight] = size.split('*').map(Number);

      // 创建一个新的 Image 对象
      const img = new Image();
      img.src = this.oriImage;

      img.onload = () => {
        // 创建一个 Canvas 元素
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 设置 Canvas 尺寸为传入的尺寸
        canvas.width = newWidth;
        canvas.height = newHeight;

        // 将图片绘制到 Canvas 上，并进行缩放
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        // 生成新的 PNG 数据 URL
        const dataURL = canvas.toDataURL('image/png');

        // 创建一个下载链接
        const link = document.createElement('a');
        link.href = dataURL;
        link.download =  `${this.title}.png`; // 设置下载文件名

        // 触发点击下载
        link.click();
      };

      img.onerror = () => {
        console.error('图片加载失败');
      };
    },
    selectNavItem(index) {
      this.selectedNavIndex = index
    },
    GenerateManagementWindowClass() {
      this.GenerateManagementWindowActive = !this.GenerateManagementWindowActive
    }
  }
}
</script>


<style>
@import "GenerateManagement.css";
.scaled-image {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 等比例缩放，保持图片完整 */
}
</style>
